import { Flex } from 'antd'
import React, { useMemo } from 'react'

import styles from './page-header.module.css'

export interface LayoutPageHeaderProps {
  leftSection?: React.ReactNode;
  rightSection?: React.ReactNode;
}

export default function PageHeader({ leftSection, rightSection }: LayoutPageHeaderProps) {
  const left = useMemo(() => {
    return typeof leftSection === 'string' ? (
      <span className={styles.title}>{leftSection}</span>
    ) : (
      leftSection
    )
  }, [leftSection])

  return (
    <Flex className={styles.layoutPageHeader}>
      {left}
      {rightSection}
    </Flex>
  )
}
